<div class="nodes-summary">
  <div *ngIf="selection?.length !== 1" class="arm-summary">{{selection?.length || 0}} Items selected</div>
  <div *ngIf="selection?.length === 1" class="arm-summary">
    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Name:</span>
      <span [title]="selection[0].name" class="arm-summary-value" fxFlex>{{selection[0].name}}</span>
    </div>
    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Teams Role:</span>
      <span [title]="selection[0].teamsRole" class="arm-summary-value" fxFlex>{{selection[0].teamsRole}}</span>
    </div>
    <div *ngIf="selection[0].productType !== 'THIRD_PARTY'" class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Address:</span>
      <span [title]="selection[0].addressForGUI" class="arm-summary-value" fxFlex>{{selection[0].addressForGUI}}</span>
    </div>
    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Device type:</span>
      <span [title]="selection[0].deviceTypeS" class="arm-summary-value" fxFlex>{{selection[0].deviceTypeS}}</span>
    </div>
    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Product type:</span>
      <span [title]="selection[0].productType" class="arm-summary-value" fxFlex>{{selection[0].productType}}</span>
    </div>

    <div *ngIf="selection[0].productType !== 'THIRD_PARTY'">
      <div class="arm-summary-item" fxLayout="row">
        <span class="arm-summary-name" fxFlex="45">Software version:</span>
        <span [title]="selection[0].softwareVersion" class="arm-summary-value"
              fxFlex>{{selection[0].softwareVersion}}</span>
      </div>
      <div class="arm-summary-item" fxLayout="row">
        <span class="arm-summary-name" fxFlex="45">Primary serial:</span>
        <span [title]="selection[0].serialNum" class="arm-summary-value" fxFlex>{{selection[0].serialNum}}</span>
      </div>
    </div>

    <div *ngIf="selection[0].prevSerialNum != ''" class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Secondary serial:</span>
      <span [title]="selection[0].prevSerialNum" class="arm-summary-value" fxFlex>{{selection[0].prevSerialNum}}</span>
    </div>

    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Administrative State:</span>
      <span [title]="selection[0].adminState" class="arm-summary-value" fxFlex>{{selection[0].adminState}}</span>
    </div>

    <div *ngIf="selection[0].productType !== 'THIRD_PARTY'">
      <div class="arm-summary-item" fxLayout="row">
        <span class="arm-summary-name" fxFlex="45">Operative State:</span>
        <div class="arm-summary-value map-summary-item-value-operative-state" fxFlex>
          <span (click)="isCollapsed = !isCollapsed"
                ng-style="node.operState.state === 15 ? {color: '#3382C6'} : {color:  'red'} ">{{selection[0].operState.description}}</span>
          <i (click)="isCollapsed = !isCollapsed"
             [ngClass]="isCollapsed ? 'fa fa-angle-down fa-lg oper-state' : 'fa fa-angle-up fa-lg oper-state'"></i>
        </div>
      </div>

      <div *ngIf="!isCollapsed">
        <span class="map-summary-device-left-operative-state">Configurator</span>
        <i [ngClass]="nodeOperativeStateToColor(selection[0].operState.state).c2n"
           aria-hidden="true"
           class="fa fa-long-arrow-right fa-lg"></i><span
        class="map-summary-device-right-operative-state">Node</span>
        <br/>
        <span class="map-summary-device-left-operative-state">Node</span>
        <i [ngClass]="nodeOperativeStateToColor(selection[0].operState.state).n2c"
           aria-hidden="true"
           class="fa fa-long-arrow-right fa-lg"></i><span
        class="map-summary-device-right-operative-state">Configurator</span>
        <br/>
        <span class="map-summary-device-left-operative-state">Node</span>
        <i [ngClass]="nodeOperativeStateToColor(selection[0].operState.state).n2rR"
           aria-hidden="true"
           class="fa fa-long-arrow-right fa-lg"></i><span
        class="map-summary-device-right-operative-state">Router *</span>
        <br/>
        <span class="map-summary-device-left-operative-state">Node *</span>
        <i [ngClass]="nodeOperativeStateToColor(selection[0].operState.state).n2rN"
           aria-hidden="true"
           class="fa fa-long-arrow-right fa-lg"></i><span
        class="map-summary-device-right-operative-state">Router</span>
        <br>
        <span class="map-summary-device-comment"> * Reporting element </span>
        <div *ngIf="selection[0].routingServerGroupId < 1">
          <br>
          <span class="map-summary-device-comment" style="color:red">There is no routing server group selected</span>
          <br/>
        </div>
      </div>
    </div>

  </div>
</div>
